export const SUGGESTIONS_LABEL = 'Sugestões';
export const SUGGESTIONS_DESCRIPTION = 'Clique para selecionar o gestor de férias';
export const MULTIPLE_MANAGERS_HINT =
  'Você tem alocações vigentes com gestores diferentes. Confira quem aprova.';
export const ALLOCATION_HINT_TEMPLATE = 'Sugerido pela alocação em {client}';
export const REGISTRY_MANAGER_LABEL = 'Responsável no cadastro';
export const SEARCH_RESULTS_LABEL = 'Resultados da busca';
export const ALLOCATION_MANAGER_BADGE = 'Gestor de alocação';
export const NO_RESULTS = 'Nenhum resultado encontrado.';
export const SEARCH_ERROR = 'Busca indisponível no momento. Tente novamente.';
export const SEARCHING = 'Buscando...';
